import { render } from "./FoundingView.vue?vue&type=template&id=7b517d64"
import script from "./FoundingView.vue?vue&type=script&lang=js"
export * from "./FoundingView.vue?vue&type=script&lang=js"

import "./FoundingView.vue?vue&type=style&index=0&id=7b517d64&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__